/* src/app/components/shared/model/ship-methods/ship-methods.component.scss */
.shippingmethodDialog .dialog-title {
  color: #FFFFFF;
  font-size: 21px;
}
.shippingmethodDialog .header {
  background-color: var(--theme-deafult-secondary);
}
.shippingmethodDialog .header-tab-action {
  background: rgba(0, 0, 0, 0.1490196078) !important;
  margin: 0px 5px;
  border-radius: 10px;
  color: #FFFFFF;
}
.shippingmethodDialog .mat-mdc-dialog-content {
  margin: 0px;
  padding: 23px 25px;
}
.shippingmethodDialog .mat-mdc-dialog-actions {
  margin: 0px;
  padding: 23px 25px;
}
.shippingmethodDialog .mat-mdc-dialog-actions .updateButton {
  background-color: var(--theme-deafult);
  color: #FFFFFF;
}
::ng-deep .shippingmethodDialog .mat-mdc-dialog-container {
  margin: 0px;
  padding: 0px !important;
}
/*# sourceMappingURL=ship-methods.component.css.map */
